<template>
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
        <div>
            <svg-icon class-name="international-icon" icon-class="language" />
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="language === 'eng'" command="eng">
                English
            </el-dropdown-item>
            <el-dropdown-item :disabled="language === 'cht'" command="cht">
                繁體中文
            </el-dropdown-item>
            <el-dropdown-item :disabled="language === 'chs'" command="chs">
                简体中文
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>

export default {
    inject: ['reload'],
    computed: {
        language() {
            return this.$store.getters.language
        }
    },
    methods: {
        handleSetLanguage(lang) {
            this.$i18n.locale = lang
            this.$store.dispatch('setLanguage', lang)
            this.$message({
                message: this.$t('_switch_language'),
                type: 'success'
            })  
           // 暫時屏蔽刷新(解決子組件默認值切換多語言未刷新問題)
           // this.reload();
            this.$forceUpdate()
        }
    }
}
</script>
